module.exports = __webpack_public_path__ + "media/images/landing_pages/car_insurance-43519d5700b5faa6e03bd5f3641ee6ed.svg";